<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="terms-of-service">
      <div class="terms-of-service-title">
        <span class="text">利用規約</span>
      </div>
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">
              <span>株式会社Iranoan（以下「当社」といいます。）が提供する本サイトにおいて提供するサービス</span>
              <span>（以下「本件サービス」といいます。）に関する条件及び当社とサービス利用者との権利義務関係について、以下のとおりサイト利用規約</span>
              <span>（その他の当社が契約の内容として別に定めるものを含みます。</span>
              <span>以下「本件規約」といいます。）として定めます。</span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第1条（用語の定義）"
        >
          <div class="text-container">
            <span class="text">
              本件規約における以下の各号の用語の意味は、当該各号に定めるとおりとします。
            </span>
            <span class="text">
              (1)「当社」とは、本サービスを提供する株式会社Iranoanのことをいいます。
            </span>
            <span class="text">
              (2)「本サイト」とは、当社が提供するサイト https://wanana.iranoan.com のことをいいます。
            </span>
            <span class="text">
              (3)「本規約」とは、サービス利用者が遵守すべき規定のことをいいます。
            </span>
            <span class="text">
              (4)「サービス利用契約」とは、本件サービスの利用に関する契約をいいます。
            </span>
            <span class="text">
              (5)「サービス利用者」とは、当社とサービス利用契約を締結した者をいいます。
            </span>
            <span class="text">
              (6)「アカウント」とは、サービス利用者が本件サービスに登録したサービス利用者に関する情報をいいます。
            </span>
            <span class="text">
              (7)「パスワード」とは、お客様自身で作成した英数字の組み合わせで構成される暗号をいいます。
            </span>
            <span class="text">
              (8)「メールアドレス」とは、サービス利用者が本サービスにご登録いただいたメールアドレスをいいます。
            </span>
            <span class="text">
              (9)「ポイント」とは、本サイト内で使う事が出来る仮想通貨をいいます。
            </span>
            <span class="text">
              (10)「商品」とは、本サイト内のゲームで獲得できるカードを示します。
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第2条（適用範囲）"
        >
          <div class="text-container">
            <span class="text">
              1 サービス利用者は、本規約の定めに従って本サイトを使用しなければならず、本規約に同意しない限り本サイトを利用できません。
            </span>
            <span class="text">
              <span>2 サービス利用者が、本サイトの登録画面において、本規約への同意手続を行った時点で、サービス利用者と当社との間で、本規約の諸規定に従った利用契約</span>
              <span>（以下「本利用契約」といいます。）が成立し、本規約の内容がサービス利用者と当社との間の契約内容となります。</span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第3条（本件サービスの内容等）"
        >
          <div class="text-container">
            <span class="text">
              1 本件サービスの内容・利用手順は、ご利用ガイドに記載のとおりです。
            </span>
            <span class="text">
              2 当社は、自らの判断により、随時本件サービスの内容を変更または提供を終了することができます。
            </span>
            <span class="text">
              3 サービス利用者は、当社による本件サービスの内容の変更もしくは提供の終了について異議を唱え、または損害賠償その他の請求を行うことはできません。
            </span>
            <span class="text">
              4 本件サービスの提供を終了する場合、当社の定める方法によって利用契約者に事前に通知するものとします。
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第4条（利用申込み）"
        >
          <div class="text-container">
            <span class="text">
              <span>1 本件サービスの利用を希望する場合は、本サイトにアクセスし、本件規約に同意の上、本件サービスの利用申込み</span>
              <span>（以下、本条において「サービス利用申込み」といいます。）を行うものとします。</span>
            </span>
            <br>
            <span class="text">
              <span>2 サービス利用申込みに対し、当社が承諾することにより、当社とサービス利用申込みを行った方</span>
              <span>（以下、本条において「サービス利用申込者」といいます。）との間に、本件規約に基づくサービス利用契約が締結されます。</span>
            </span>
            <span class="text">
              <span>3 本サイトの利用希望者が未成年者等である場合、本サイトの利用に際し、事前に親権者等の法定代理人の同意を得るものとします。</span>
              <span>未成年者等が本規約に同意した場合は、法定代理人の同意を得たものとみなし、一切の責任は負いかねます。</span>
            </span>
            <span class="text">
              4 当社は、サービス利用申込みを承諾しない場合があります。この場合において、当社は、その理由を開示する義務を負いません。
            </span>
            <span class="text">
              5 サービス利用申込者は、サービス利用申込みに際して不正確な情報または虚偽の情報を送信してはなりません。
            </span>
            <span class="text">
              6 アカウント情報の誤りまたは変更の遅延その他の不備により、本件サービスの利用に支障が生じた場合であっても、当社は当該支障について責任を負いません。
            </span>
            <span class="text">
              <span>7 本規約及びポイント利用規約は、当社が企画開発し、運営提供する</span>
              <span>https://wanana.iranoan.com における、有料サービスをご利用いただく上で、当社とサービス利用者間における取り決めを定めるものです。</span>
            </span>
            <span class="text">
              8 有料サービスを利用する全てのユーザーは本規約の取り決めを遵守する事とします。
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第5条（サービス利用者によるサービス利用契約の解約）"
        >
          <div class="text-container">
            <span class="text">
              サービス利用者は、本件サービス上での解約手続きその他の当社が別途指定する解約手続きを行うことにより、いつでもサービス利用契約を解約することができます。
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第6条（本件サービスの利用登録）"
        >
          <div class="text-container">
            <span class="text">
              <span>1 サービス利用者が本件サービスを利用するために必要な端末、通信機器、ソフトウェア、インターネットへの接続に関する契約等の準備は、</span>
              <span>サービス利用者が自己の費用と責任において準備しなければなりません。</span>
            </span>
            <span class="text">
              2 当社は、サービス利用者による本件サービスの利用環境について一切関与せず、また一切の責任を負いません。
            </span>
            <span class="text">
              <span>3 サービス利用者は、登録時にご自身のメールアドレスを登録することで、これを本件サービスにおけるメールアドレスとして利用出来ます。</span>
              <span>なお、サイト内でメールアドレスの変更はできかねますので誤ったメールアドレスで登録を</span>
              <span>した場合やメールアドレスの変更がある際は、本人確認をさせていただいた上で当社において変更を行わせていただきます。</span>
            </span>
            <span class="text">
              <span>4 サービス利用者は、原則としてお１人様１アカウントとし、複数アカウントの所持を禁止します。</span>
              <span>なお、当社は、サービス利用者の複数アカウントの所持が発覚した場合、事前の告知無く当該サービス利用者の所持するアカウントを削除します。</span>
              <span>この際、削除したアカウントに課金されているポイントは全て失効します。</span>
            </span>
            <span class="text">
              5 本サイトの運営が困難であると当社が判断した場合、当該要因が解消されるまで、当社はサービス利用者に対し、本サービスの利用を制限する事が出来るものとします。
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第7条（アカウントの管理）"
        >
          <div class="text-container">
            <span class="text">
              <span>1 利用者は、利用に際して登録した情報（以下、「登録情報」といいます。メールアドレスやID</span>
              <span>・パスワード等を含みます）について、自己の責任の下に登録、管理するものとします。利用者</span>
              <span>は、これを第三者に利用させ、または貸与、譲渡、名義変更、売買などをしてはならないものと</span>
              <span>します。</span>
            </span>
            <span class="text">
              <span>2 当社は、登録情報によって本サービスの利用があった場合、利用登録をおこなった本人が利用</span>
              <span>したものと扱うことができ、当該利用によって生じた結果ならびにそれに伴う一切の責任につい</span>
              <span>ては、利用登録を行った本人に帰属するものとします。</span>
            </span>
            <span class="text">
              <span>3 利用者は、登録情報の不正使用によって当社または第三者に損害が生じた場合、当社および第</span>
              <span>三者に対して、当該損害を賠償するものとします。</span>
            </span>
            <span class="text">
              <span>4 登録情報の管理は、利用者が自己の責任の下で行うものとし、登録情報が不正確または虚偽で</span>
              <span>あったために利用者が被った一切の不利益および損害に関して、当社は責任を負わないものとし</span>
              <span>ます。</span>
            </span>
            <span class="text">
              <span>5 登録情報が盗用されまたは第三者に利用されていることが判明した場合、利用者は直ちにその</span>
              <span>旨を当社に通知するとともに、当社からの指示に従うものとします。</span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第8条（サービス利用者の義務）"
        >
          <div class="text-container">
            <span class="text">
              <span>1 サービス利用者は、当社が別途明示的に許可した場合を除き、本件サービスに関し、</span>
              <span>以下の各号の行為を行ってはなりません。</span>
            </span>
            <span class="text">
              (1) 法令に違反する行為
            </span>
            <span class="text">
              (2) 本件規約に違反する行為
            </span>
            <span class="text">
              (3) 当社または第三者に不当に不利益または損害を生じさせる行為
            </span>
            <span class="text">
              (4) 本件サービスの各機能の目的外利用
            </span>
            <span class="text">
              <span>(5) 本件サービスを通常利用する際に用いられる方法とは異なる方法（自動化、スクレイピング</span>
              <span>を含みます。）による本件サービスの利用</span>
            </span>
            <span class="text">
              (6) 当社または第三者の知的財産権侵害
            </span>
            <span class="text">
              (7) 当社または第三者に関するプライバシーもしくは肖像権の侵害
            </span>
            <span class="text">
              (8) 当社または第三者の秘密情報の漏洩
            </span>
            <span class="text">
              (9) 本件サービス内で閲覧できる情報の第三者提供
            </span>
            <span class="text">
              (10) 本人の同意を得ない第三者の個人情報の提供
            </span>
            <span class="text">
              (11) 当社または第三者に対する誹謗中傷
            </span>
            <span class="text">
              (12) 当社または第三者の名誉または信用の毀損
            </span>
            <span class="text">
              (13) 当社または第三者へのなりすまし
            </span>
            <span class="text">
              (14) 第三者のアカウント情報の利用
            </span>
            <span class="text">
              (15) 本件サービスの提供に用いられるシステムに記録された情報の改ざんまたは消去
            </span>
            <span class="text">
              <span>(16) 有害なコンピュータプログラム等の送信、または当社もしくは第三者のリクエストに応じ</span>
              <span>て送信可能な状態におくこと</span>
            </span>
            <span class="text">
              (17) 他のサービス及び商品等並びに団体及び組織等の広告、宣伝または勧誘
            </span>
            <span class="text">
              (18) 本件サービスの提供その他の業務の妨害
            </span>
            <span class="text">
              (19) コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報の送信
            </span>
            <span class="text">
              <span>(20) 本件サービスの提供に用いられている電気通信設備（サーバーを含みますがこれに限りま</span>
              <span>せん。以下、「電気通信設備」といいます。）に過度な負荷をかける行為</span>
            </span>
            <span class="text">
              <span>(21) 本件サービスの提供に用いられるシステムに設定されたアクセス制御機能の解除または回</span>
              <span>避その他の不正アクセス</span>
            </span>
            <span class="text">
              <span>(22) 本件サービスに用いられるソフトウェアの複製、修正、転載、改変、変更、リバースエン</span>
              <span>ジニアリング、逆アセンブル、逆コンパイル、翻訳または解析</span>
            </span>
            <span class="text">
              <span>(23) 詐欺的な手段（いわゆるフィッシング及びこれに類する手段を含みます。）による当社ま</span>
              <span>たは第三者からの情報の取得</span>
            </span>
            <span class="text">
              <span>(24) 当社に対する過度に長時間の架電、同様の問い合わせの過度の繰り返し、または義務や理</span>
              <span>由のない対応の強要</span>
            </span>
            <span class="text">
              <span>(25) 機器の販売、情報の提供、ハイパーリンクの設定等により上記各号のいずれかに該当する</span>
              <span>行為を助長する行為</span>
            </span>
            <span class="text">
              (26) 上記各号のいずれかに該当するおそれがある行為
            </span>
            <span class="text">
              (27) その他当社が不適当と判断した行為
            </span>
            <span class="text">
              <span>2 アカウント情報に変更が生じた場合、サービス利用者は遅滞なく当該変更後の情報を登録しな</span>
              <span>ければなりません。</span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第9条（個人情報の取扱い）"
        >
          <div class="text-container">
            <span class="text">
              <span>サービス利用者は、当社が個人情報保護ポリシーの定めに従ってサービス利用者の個人情報を取</span>
              <span>り扱うことに同意します。</span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第10条（サービス利用者にかかる情報の削除）"
        >
          <div class="text-container">
            <span class="text">
              <span>1 当社は、サービス利用者とのサービス利用契約が解約された場合、当該サービス利用者にかか</span>
              <span>る情報（アカウント情報、アプリ内通貨及び有償サービスにかかる情報を含みますが、これに限</span>
              <span>りません。）を削除します。</span>
            </span>
            <span class="text">
              2 当社は前項に基づき削除したサービス利用者にかかる情報の復元等は行いません。
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第11条（サービスに関する権利）"
        >
          <div class="text-container">
            <span class="text">
              <span>当社より、本件サービスを通じてサービス利用者に提供されるコンテンツ及び情報等に関する知</span>
              <span>的財産権その他の権利は、当社または当社に権利を許諾している第三者に帰属します。</span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第12条（有料サービスについて）"
        >
          <div class="text-container">
            <span class="text">
              <span>1 サービス利用者は、当社所定の方法により、当社が本件サービス内又は当社の提供する</span>
              <span>他のサービスで提示している金額で当社の提供するサービス内でのみ使用可能なポイント</span>
              <span>を購入することができます。なお、当社は、サービス利用者に対して、ポイントの購入に</span>
              <span>ついて購入単位、決済方法、利用期間その他の購入条件を設けることがあり、設定した購</span>
              <span>入条件及び支払可能金額等は、本件サービス内に掲載します。</span>
            </span>
            <span class="text">
              <span>2 ポイントの利用条件その他ポイントの利用に関わる条件については、本規約の他、本サ</span>
              <span>イト内に掲載するポイント利用規約の定めに従うものとします。</span>
            </span>
            <span class="text">
              <span>3 サービス利用者は、有料サービス利用料(その他有料サービスを通じてサービス利用者</span>
              <span>に債務が生じた場合はそれも含める)を、当社が別途定める支払い方法と条件に従い、支</span>
              <span>払うものとします。当社は、当社に過失があるなどの法的責任がある場合を除き、一度支</span>
              <span>払いを受けた当該料金について一切返金しないものとします。</span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第13条（商品について）"
        >
          <div class="text-container">
            <span class="text">
              1 サービス利用者は、有料サービスを利用して獲得した商品の配送を受けることが出来ます。
            </span>
            <span class="text">
              <span>2 サービス利用者は、獲得した商品を、獲得した日から14日目の24時まで保有することが出来</span>
              <span>（以下、当該期間を「保有期間」といいます。）、配送を希望する場合には、本サイトから所</span>
              <span>定の配送手続を行わなければなりません。</span>
            </span>
            <span class="text">
              <span>3 前項の保有期間を過ぎた場合、サービス利用者はそれらの商品の配送を受ける権利を失うもの</span>
              <span>とします。なお、保有期間を過ぎた商品につきましては自動的にポイント返還するものとしま</span>
              <span>す。</span>
            </span>
            <span class="text">
              <span>4 当社は、サービス利用者の獲得した商品について、配送することが当社の責めに帰すべき事由</span>
              <span>により不能であることが明らかとなった場合には、当社は、サービス利用者が当該商品を取得す</span>
              <span>るために使用したポイントをサービス利用者に対して付与することにより、その損害賠償責任を</span>
              <span>免れることとします。なお、当社は当該商品と同一の商品を取得し交付する義務を負わないもの</span>
              <span>とします。</span>
            </span>
            <span class="text">
              <span>5 商品に関する配送料は全額当社負担といたします。なお、国外への配送については別途料金を</span>
              <span>徴収する場合がございます。</span>
            </span>
            <span class="text">
              6 配送方法は当社提携先のヤマト運輸株式会社又は当社指定業者を利用いたします。
            </span>
            <span class="text">
              <span>7 配送時期は、発送依頼を受けた日から14営業日前後で発送いたします。</span>
              <span>(※追跡番号はご登録いただいたメールアドレスに送信いたします。)</span>
            </span>
            <span class="text">
              8 商品発送中の破損などのトラブルが発生した場合、当社は一切の責任を負いかねます。
            </span>
            <span class="text">
              <span>9 当社は、当該商品の配送までにサービス利用者の規約違反行為等が認められた場合には、商品</span>
              <span>の配送を停止することができるものとします。なお、これによる損害について当社は賠償する責</span>
              <span>任を負いません。</span>
            </span>
            <span class="text">
              <span>10 当社がサービス利用者に対して商品を配送した後、受け取り拒否、宛先不明等で返送され、</span>
              <span>当該サービス利用者が再送手続を行わなかった場合には、当該サービス利用者は、当該商品に関</span>
              <span>する権利の一切を失うものとします。なお、この場合であっても、当社はポイントの返還義務等</span>
              <span>の一切の補償、損害賠償義務を負いません。</span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第14条（クレジットカード等による利用）"
        >
          <div class="text-container">
            <span class="text">
              <span>1 本サイトにおいて、サービス利用者は、クレジットカードによる決済又は当社が提供す</span>
              <span>る他のサービス内においては当該サービス内で定められた方法を利用することにより、ポ</span>
              <span>イントの購入を行うことができます。ただし、決済に利用するクレジットカードは、サー</span>
              <span>ビス利用者本人名義のものであり、かつ、決済時に有効なものに限られます。</span>
            </span>
            <span class="text">
              <span>2 サービス利用者は、クレジットカード決済を利用する場合、当該サービス利用者本人名</span>
              <span>義のクレジットカードに関する情報（クレジットカードの種類、カード番号及び有効期限</span>
              <span>等をいうものとし、以下、総称して「クレジットカード情報」といいます。）を当社指定</span>
              <span>の方法により登録するものとします。</span>
            </span>
            <span class="text">
              <span>3 クレジットカード情報の誤登録等によりサービス利用者に生じた損害について、当社は</span>
              <span>一切責任を負いません。また、クレジットカードの利用に関するサービス利用者の虚偽又</span>
              <span>は不正により当社が損害を被った場合、当該サービス利用者は当社に対して、当社の被っ</span>
              <span>た一切の損害を賠償するものとします。</span>
            </span>
            <span class="text">
              <span>4 当社は、本サイトの利用のために発生した料金についてのクレジットカードによる決済</span>
              <span>時において、所定の方法によりサービス利用者が決済に利用するクレジットカードについ</span>
              <span>て、クレジットカード会社に支払い可否の承認を求めるものとし、その承認が得られない</span>
              <span>場合は、決済をしないものとすることができます。この場合、サービス利用者に損害が生</span>
              <span>じたときであっても、当社は当該損害について一切責任を負いません。</span>
            </span>
            <span class="text">
              <span>5 サービス利用者のクレジットカードによる決済が終了した後であっても、クレジットカ</span>
              <span>ード会社から当社に対し、当該クレジットカードの利用につき拒絶もしくは停止の通知が</span>
              <span>なされた場合またはクレジットカードの利用に関する当該サービス利用者の虚偽若しくは</span>
              <span>不正が判明した場合、当社はその理由のいかんを問わず、当該サービス利用者による全て</span>
              <span>の決済を中止できるものとします。</span>
            </span>
            <span class="text">
              <span>6 サービス利用者は、当社の提供する他のサービス内で本サービスに利用することができ</span>
              <span>るポイントを購入することができますが、その場合には、本サービスと同一のアカウント</span>
              <span>により購入をしなければならず、他のアカウントによりポイントを購入した場合には、本</span>
              <span>サービス内でポイントが反映されず、使用できないことを了承するものとします。なお、</span>
              <span>その場合には、当社は一切の返金等を行わず、一切の責任を負わないものとします。</span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第15条（決済機関との関係等）"
        >
          <div class="text-container">
            <span class="text">
              <span>1 サービス利用者と本サービスのために当社が用いる課金決済会社又は決済代行会社との間で本</span>
              <span>サービスの料金その他の金銭債務を巡って紛争が生じた場合、当該サービス利用者と当該会社と</span>
              <span>の間で解決するものとし、当社は、一切それに関与せず、一切の責任を負わないものとします。</span>
            </span>
            <span class="text">
              <span>2 前項の紛争がサービス利用者の責めに帰すべき事由により生じたものであって、これにより当</span>
              <span>社が損害を被った場合、当該サービス利用者は当社に対して当社の被った一切の損害を賠償する</span>
              <span>ものとします。</span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第16条（本件サービスの提供の停止等）"
        >
          <div class="text-container">
            <span class="text">
              <span>当社は、以下のいずれかの場合には、損害賠償その他の義務を負うことなく、一時的に本件サー</span>
              <span>ビスの全部または一部の提供を停止できるものとします。</span>
            </span>
            <span class="text">
              (1) 本件サービスを提供するための設備の保守または点検等を行う場合
            </span>
            <span class="text">
              (2) 火災、停電等により本件サービスの提供に支障が生じた場合
            </span>
            <span class="text">
              (3) 地震、噴火、洪水、津波等の天災により本件サービスの提供に支障が生じた場合
            </span>
            <span class="text">
              <span>(4) 戦争、動乱、暴動、騒乱、労働争議、感染症の蔓延、緊急事態宣言の発出等により本件サー</span>
              <span>ビスの提供に支障が生じた場合</span>
            </span>
            <span class="text">
              <span>(5) 本件サービスの運用上または技術上の理由により、当社が本件サービスの提供を一時的に延</span>
              <span>期または中断する必要があると判断した場合</span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第17条（利用制限等）"
        >
          <div class="text-container">
            <span class="text">
              <span>1 当社は、サービス利用者が以下の各号のいずれかに該当すると判断した場合には、サービス利 </span>
              <span>用者に事前に通知することなく、本件サービスの利用の停止、またはサービス利用契約の解約等 </span>
              <span>の措置（以下、本条において「利用制限措置」といいます。）を講じることができるものとしま </span>
              <span>す。 </span>
            </span>
            <span class="text">
              <span>(1) サービス利用者のパスワードが漏洩する事により、第三者が本サービスを不正利用した場合 </span>
              <span>、当社の他のサービスを第三者が不正に利用した場合またはこれらの恐れのある場合。 </span>
            </span>
            <span class="text">
              (2) サービス利用者の行為によって当社の事業に支障をきたすと判断した場合。
            </span>
            <span class="text">
              (3) アカウントを複数取得した(禁止行為)場合。
            </span>
            <span class="text">
              (4) 本件規約に違反し、またはそのおそれがある場合
            </span>
            <span class="text">
              (5) 前各号の他、利用制限措置を講じる必要があると当社が判断した場合
            </span>
            <span class="text">
              <span>2 当社が第１項に基づき利用制限措置を講じたことにより、サービス利用者に損害が発生した場 </span>
              <span>合であっても、当社は当該損害について一切責任を負いません。 </span>
            </span>
            <span class="text">
              <span>3 本条に基づきサービス利用契約が解約される場合、サービス利用者は当社に負っている債務に </span>
              <span>ついて期限の利益を喪失し、ただちに当社に対してすべての債務を履行しなければなりません。 </span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第18条（免責）"
        >
          <div class="text-container">
            <span class="text">
              <span>1 本件規約に特段の定めがない限り、当社は、サービス利用者に発生した損害を賠償せず、サー </span>
              <span>ビス利用者は当社に当該損害についての請求はできません。また、サービス利用者は、本件サー </span>
              <span>ビスの利用や利用の終了等により第三者に対し損害を与えた場合、自己の責任でこれを解決し、 </span>
              <span>当社は責任を負担しません。ただし、当該損害が当社の故意または重過失によって生じた場合に </span>
              <span>はこの限りではありません。 </span>
            </span>
            <span class="text">
              <span>2 当社は、天災地変、戦争、暴動、内乱、延焼による火災、洪水、法令の改廃制定、停電、公権 </span>
              <span>力の介入、ストライキその他の労働争議、輸送機関の事故、感染症の蔓延、緊急事態宣言の発令 </span>
              <span>その他当社の責に帰すべからざる事由より生じたサービス利用契約上の義務の不履行について、 </span>
              <span>損害賠償責任その他一切の責任を負いません。 </span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第19条（サービス利用者への通知）"
        >
          <div class="text-container">
            <span class="text">
              <span>サービス利用者は、当社からサービス利用者への通知が以下のいずれかの方法にて行われること</span>
              <span>に同意します。</span>
            </span>
            <span class="text">
              <span>(1) 本件サービス内に掲載して行います。この場合は、掲載された時をもってサービス利用者に</span>
              <span>対する通知が完了したものとみなします。</span>
            </span>
            <span class="text">
              <span>(2) 当社のWebサイト上に掲載して行います。この場合は、掲載された時をもってサービス利用</span>
              <span>者に対する通知が完了したものとみなします。</span>
            </span>
            <span class="text">
              <span>(3) サービス利用者が利用申込みの際またはその後に当社に届け出たサービス利用者の電子メー</span>
              <span>ルアドレス宛に電子メールを送信して行います。この場合は、サービス利用者の電子メールアド</span>
              <span>レス宛に電子メールを送信した時をもってサービス利用者に対する通知が完了したものとみなし</span>
              <span>ます。</span>
            </span>
            <span class="text">
              <span>(4) その他、当社が適切と判断する方法で行います。この場合は、当該通知の中で当社が指定し</span>
              <span>た時をもってサービス利用者に対する通知が完了したものとみなします。</span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第20条（反社会的勢力の排除）"
        >
          <div class="text-container">
            <span class="text">
              サービス利用者は、次の各号について表明し、保証します。
            </span>
            <span class="text">
              <span>(1) 過去または将来において、自らが反社会的勢力（暴力団、暴力団員、暴力団準構成員、暴力</span>
              <span>団関係企業、総会屋、社会運動等標ぼうゴロ、政治活動標ぼうゴロまたは特殊知能暴力集団等を</span>
              <span>含む。以下同じ。）ではないこと、反社会的勢力と取引きを行っていないこと、資金提供等の行</span>
              <span>為を通じて反社会的勢力の維持、運営に協力もしくは関与していないこと、その他反社会的勢力</span>
              <span>との意図的な交流がないこと</span>
            </span>
            <span class="text">
              <span>(2) 自らまたは第三者を利用して、当社または当社の従業員に対して、暴行・傷害・脅迫・恐喝</span>
              <span>・威圧等の暴力的もしくは脅迫的行為または風説の流布や偽計等の詐欺的手法を用いた要求、合</span>
              <span>理的な範囲を超える不当な要求、業務の妨害、名誉・信用の毀損等をおこなわないこと</span>
            </span>
            <span class="text">
              <span>(3) 自らが、反社会的勢力であること、または反社会的勢力と関係がある旨を、当社または第三</span>
              <span>者に伝える等の行為をしないこと</span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第21条（サービス利用契約上の地位の移転等）"
        >
          <div class="text-container">
            <span class="text">
              <span>1 サービス利用者は、サービス利用契約上の地位またはサービス利用契約に関して有する権利も</span>
              <span>しくは義務について、第三者に譲渡、承継、売買、名義変更、担保設定等をすることはできませ</span>
              <span>ん。</span>
            </span>
            <span class="text">
              <span>2 事業譲渡、会社分割、合併等の方法を問わず、当社が第三者に対して本件サービスにかかる事</span>
              <span>業の譲渡または承継（以下「事業譲渡等」といいます。）をする場合には、当社は当該事業譲渡</span>
              <span>等に伴い、サービス利用契約上の地位、サービス利用契約に基づく権利及び義務並びにアカウン</span>
              <span>ト情報を取り扱う権限を、サービス利用者の別段の同意を得ることなく当該事業譲渡等の譲受人</span>
              <span>に譲渡または承継することができるものとします。</span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第22条（義務の存続）"
        >
          <div class="text-container">
            <span class="text">
              <span>サービス利用契約が終了した場合であっても、サービス利用者は、サービス利用契約の終了前に</span>
              <span>発生した義務を免れません。</span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第23条（本件件規約の変更）"
        >
          <div class="text-container">
            <span class="text">
              <span>1 当社は、以下の各号の場合には、サービス利用者の事前の承諾を得ることなく、本件規約を変</span>
              <span>更できるものとします。この場合、当社は、事前に変更後の利用規約をサービス利用者に通知し</span>
              <span>ます。</span>
            </span>
            <span class="text">
              (1) 本件規約の変更内容がサービス利用者の一般の利益に適合する場合
            </span>
            <span class="text">
              <span>(2) 本件利用規約の変更がサービス利用契約の目的に反せず、かつ、変更の必要性、変更後の内</span>
              <span>容の相当性、その他変更にかかる事情に照らして合理的である場合</span>
            </span>
            <span class="text">
              <span>2 当社は、前項に定める他、サービス利用者から本件利用規約の変更について同意を得ることに</span>
              <span>より、本件利用規約を変更できるものとします。</span>
            </span>
            <span class="text">
              3 以下の各号の場合には、サービス利用者は、本件利用規約の変更に同意したものとみなします。
            </span>
            <span class="text">
              <span>(1) 当社が変更の１ヶ月以上前にサービス利用者に対して本件利用規約の変更案及び本件利用規</span>
              <span>約の変更日を通知し、本件利用規約の変更日までにサービス利用者から当社に対し、書面により</span>
              <span>本件利用規約の変更に対する反対の意思表示がなされなかった場合</span>
            </span>
            <span class="text">
              <span>(2) 当社がサービス利用者に対して本件利用規約の変更案及び本件利用規約の変更日を通知し、</span>
              <span>かつサービス利用者が当該変更日以降に本件サービスを利用した場合</span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="第24条（裁判管轄）"
        >
          <div class="text-container">
            <span class="text">
              <span>本件規約またはサービス利用契約に関するサービス利用者と当社との間の訴訟については、</span>
              <span>さいたま地方裁判所を第一審の専属的合意管轄裁判所とします。</span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">
              2021年11月10日 制定
            </span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';

export default {
  name: 'TermsOfService',

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.terms-of-service{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  color: #4a3f3a;
  .terms-of-service-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 360px;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
